'use client';

import { usePathname } from 'next/navigation';

import {
  ArticleDetailDefaultStatisticsChart,
  ArticleDetailStatisticsChart,
  ArticleDetailGuestStatisticsChart,
} from '@/features/ArticleDetail';
import { useAuth } from '@/shared/hooks';
import type { ArticleStatisticsData } from '@/entities/article';

interface ArticleStatisticsProps {
  data: ArticleStatisticsData | null;
}

const ArticleStatistics = ({ data }: ArticleStatisticsProps) => {
  const { isAuth } = useAuth();
  const path = usePathname();

  const isGuest = !isAuth;
  const isDataEmpty = data === null;

  if (isGuest)
    return <ArticleDetailGuestStatisticsChart redirectUrlAfterLogin={path} />;
  if (isDataEmpty) return <ArticleDetailDefaultStatisticsChart />;

  return <ArticleDetailStatisticsChart data={data} />;
};

export default ArticleStatistics;
